import { render, staticRenderFns } from "./AllFilesTable.vue?vue&type=template&id=1450f095&scoped=true&"
import script from "./AllFilesTable.vue?vue&type=script&lang=js&"
export * from "./AllFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllFilesTable.vue?vue&type=style&index=0&id=1450f095&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450f095",
  null
  
)

export default component.exports